var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { filterEmptyParams } from '@/utils/helpers';
import axiosClient from '@/utils/axiosClient';
export var getAllDisplay = function (payload) {
    return new Promise(function (resolve) {
        var _a;
        if (payload) {
            var queryString = payload.queryString;
            var filters = (_a = queryString.filters) !== null && _a !== void 0 ? _a : {};
            filters = filterEmptyParams(filters);
            var queryParser = __assign(__assign({}, queryString), { filters: filters != null
                    ? Object.entries(filters)
                        .map(function (_a) {
                        var key = _a[0], value = _a[1];
                        return "".concat(key, ":").concat(value);
                    })
                        .join('/')
                    : undefined });
            var url = "".concat(process.env.API_URL, "/display/getAllDisplays");
            axiosClient
                .post(url, null, {
                params: queryParser,
            })
                .then(function (res) { return resolve(res); });
        }
    });
};
